import http from '../http-common';
import store from '@/store';


class CategoryConfiguration {

    public getCategoryConfigurations(){
    
        const ConfigurationInfo: any = {
          category : store.state.levelTwoCategory.levelTwoCategoryName,
          subCategory :store.state.levelThreeCategory.levelThreeCategoryName,
          token: token
        }
       return  http.post('../../selfcare/fetchCategoryMasterData',ConfigurationInfo, {
            headers: {
              Authorization: 'Basic YWRtaW46Z09Wb24/NlFGKA==',
            },
          })
    }
}

export default new CategoryConfiguration();